<template>
    <div class="card blur shadow mt-8">
        <div class="card-header pb-0 mb-0 text-left bg-transparent">
            <h3 class="font-weight-bolder text-primary text-gradient">Tracking</h3>
        </div>
        <div class="card-body pt-1">
            <form @submit.prevent="Tracking">
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" name="kode" class="form-control" placeholder="kode" v-model="tracking.kode">
                        <button class="input-group-text bg-gradient-primary text-white">
                            <font-awesome-icon icon="search" fixed-width />
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="card blur shadow mt-3">
        <div class="card-header pb-0 mb-0 text-left bg-transparent">
            <h3 class="font-weight-bolder text-primary text-gradient">Permohonan Baru</h3>
        </div>
        <div class="card-body pt-1">
            <div class="d-flex flex-column flex-md-row justify-content-between">
                <router-link :to="{ name: 'ujilab.pengajuan' }" class="btn mb-0 bg-gradient-primary text-truncate">Uji
                    Lab</router-link>
                <div class="mb-3    "></div>
                <router-link :to="{ name: 'penyewaan.pengajuan.create' }" class="btn mb-0 bg-gradient-primary text-truncate">Penyewaan Alat Berat</router-link>
            </div>
        </div>
    </div>
    <div class="card blur shadow mt-3">
        <div class="card-body">
            <router-link to="auth-login" class="btn w-100 mb-0 bg-gradient-info text-truncate">Masuk</router-link>
        </div>
</div>
</template>

<script>




export default {
    name: 'Guest',
    data() {
        return {
            tracking: {
                kode: '',
            },
            errors: {},
        }
    },
    methods: {
        Tracking() {
            this.axios.get('pengajuan/' + this.tracking.kode).then((response) => {
                if (response.data.data) {
                    this.$router.push({ name: 'tracking.tracking', params: { id: this.tracking.kode } });
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: `Terjadi Kesalahan`,
                        text: `Data tidak di temukan`,
                    })
                }
            });

        }
    },
    mounted() {
    }
}
</script>